import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, RedirectCommand, Route, Router, RouterOutlet } from "@angular/router";
import { FirebaseService } from "../services/firebase.service";
import { HttpClient } from "@angular/common/http";
import { AnyCatcher } from "rxjs/internal/AnyCatcher";
import { dateTimestampProvider } from "rxjs/internal/scheduler/dateTimestampProvider";
import { IP } from "../models/ip.models";
import { OtherservicesService } from "../services/otherservices.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { DocumentData, serverTimestamp } from "firebase/firestore";
import firebase from "firebase/compat/app";
import { environment } from "../../environments/environment.development";


@Component({
  selector: 'app-home',
  standalone: true,
  // imports: [RouterOutlet],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})

export class HomeComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private firebaseService: FirebaseService, private router: Router, private http: HttpClient, private otherService: OtherservicesService, private deviceService: DeviceDetectorService) { }


  // collectionName = 'backlinks_prod'
  // this is test for git ignore
  collectionName = environment.COLLECTION_NAME
  searchVal = 'backlink'
  deviceDetails = environment.DETAILS_COLLECTION
  isProcessing = false;
  theIPVal: any;



  async ngOnInit(): Promise<void> {
    if (this.isProcessing) return;
    this.isProcessing = true;

    // Parallelize network requests for massive speed boost
    const locationPromise = this.fetchLocationData();
    const linkPromise = this.fetchLinkData();

    try {
      // Wait for both to finish simultaneously
      const [locResult, docData] = await Promise.all([locationPromise, linkPromise]);
      
      if (!docData || docData.length === 0) {
        this.router.navigate(['/error']);
        return;
      }

      const backlinkData = this.activatedRoute.snapshot.paramMap.get('id');
      const docID = docData[0]['id'];
      const redirectURL = docData[0]['data']['redirectURL'];

      console.log('Processing analytics for:', backlinkData);
      
      // Await analytics to ensure they don't drop on page unload
      await this.updateDocs(docID, backlinkData);

      // Redirect immediately to target URL
      if (redirectURL) {
        window.location.href = redirectURL;
      }

    } catch (err) {
      console.error('Critical error during redirect sequence:', err);
      this.isProcessing = false;
      this.router.navigate(['/error']);
    }
  }

  private async fetchLocationData() {
    try {
      const httpsEndPoint = environment.IPIFY_END_POINT || 'https://api.ipify.org?format=json';
      const ipResponse: any = await this.http.get(httpsEndPoint).toPromise();
      const ipv4 = ipResponse?.ip;

      const val: any = await this.otherService.getLocation(ipv4).toPromise();
      this.theIPVal = val;
      
      if (this.theIPVal && ipv4 && !this.theIPVal.ip) {
        this.theIPVal.ip = ipv4;
      }
      return val;
    } catch (err) {
      console.error('Error fetching location data, falling back...', err);
      return null;
    }
  }

  private async fetchLinkData() {
     const backlinkData = this.activatedRoute.snapshot.paramMap.get('id');
     if (!this.collectionName || !backlinkData) return null;
     
     return await this.firebaseService.multiQuery(this.collectionName, this.searchVal, backlinkData, 'deleted', false);
  }



  ipList: any

  async updateDocs(backlinkID: string, backlink: string | null) {
    try {
      console.log('Updating docs...');

      await this.updateUnique(this.theIPVal, backlink, backlinkID);
      await this.updateTheDetails(this.theIPVal, backlink);

      // Increment total engagements
      await this.updateTheBacklinks(backlinkID, 'engagements');

      // Map and increment Device, Browser, OS arrays
      const browser = this.deviceService.browser.toLowerCase();
      const device = this.deviceService.deviceType.toLowerCase();
      const os = this.deviceService.os.toLowerCase();

      // Browser mapping
      let browserKey = 'unknown';
      if (browser.includes('chrome')) browserKey = 'chrome';
      else if (browser.includes('firefox')) browserKey = 'firefox';
      else if (browser.includes('safari')) browserKey = 'safari';
      else if (browser.includes('opera')) browserKey = 'opera';
      else if (browser.includes('ie')) browserKey = 'ie';
      else if (browser.includes('edge')) browserKey = 'edge';
      else if (browser.includes('messenger')) browserKey = 'fb_messenger';

      // OS mapping
      let osKey = 'unknown';
      if (os.includes('windows')) osKey = 'windows';
      else if (os.includes('mac')) osKey = 'mac';
      else if (os.includes('linux')) osKey = 'linux';
      else if (os.includes('ios')) osKey = 'ios';
      else if (os.includes('android')) osKey = 'android';

      // Device mapping
      let deviceKey = 'unknown';
      if (this.deviceService.isDesktop()) deviceKey = 'desktop';
      else if (this.deviceService.isMobile()) deviceKey = 'mobile';
      else if (this.deviceService.isTablet()) deviceKey = 'tablet';

      // Perform transactional increments
      if (this.collectionName) {
        let promises: Promise<any>[] = [
          this.firebaseService.incrementNestedArrayField(this.collectionName, backlinkID, 'browsers', browserKey),
          this.firebaseService.incrementNestedArrayField(this.collectionName, backlinkID, 'devices', deviceKey),
          this.firebaseService.incrementNestedArrayField(this.collectionName, backlinkID, 'os', osKey)
        ];

        if (this.theIPVal && this.theIPVal.latitude != null && this.theIPVal.longitude != null) {
          promises.push(
            this.firebaseService.appendToArrayField(this.collectionName, backlinkID, 'locations', {
              latitude: this.theIPVal.latitude,
              longitude: this.theIPVal.longitude
            })
          );
        }

        await Promise.all(promises);
      }

      console.log('Docs updated successfully');
    } catch (err) {
      console.error('Error updating docs:', err);
    }
  }


  async updateTheDetails(val: any, backlinkData: string | null) {

    console.log('Update details running')
    if (!this.deviceDetails) return;

    await this.firebaseService.addDataToCollection(this.deviceDetails, {
      ip: val["ip"],
      latitude: val["latitude"] || null,
      longitude: val["longitude"] || null,
      browser: this.deviceService.browser,
      device: this.deviceService.device,
      device_type: this.deviceService.deviceType,
      orientation: this.deviceService.orientation,
      os: this.deviceService.os,
      os_version: this.deviceService.os_version,
      userAgent: this.deviceService.userAgent,
      timestamp: serverTimestamp(),
      backlinkDetails: backlinkData
    })
  }



  async updateUnique(val: any, backlinkData: string | null, backlinkID: string) {

    console.log('Update the unique running')
    if (!this.deviceDetails) return;

    const q = await this.firebaseService.multiQuery(this.deviceDetails, 'backlinkDetails', backlinkData, 'ip', val['ip'])

    if (q['length'] > 0) {
      console.log('User already visited this link. Skipping unique visitor increment.')
      return
    }

    await this.updateTheBacklinks(backlinkID, 'uniqueVisitors')
  }

  async updateTheBacklinks(docID: string, parameter: string) {
    if (this.collectionName == undefined)
      return
    await this.firebaseService.incrementFirestore(this.collectionName, docID, parameter)
  }


}





